var styles = {"textLinkWrapper":"VBG__DS__text-link-module__oH0MP","bold":"VBG__DS__text-link-module__2oQvB"};

export { styles as default };
